import { apiClientPbx } from '@/api/sipmovil_auth_api.js';

/**
 * Servicio para manejar archivos adjuntos del chat de Sipmovil
 */
export default {
  /**
   * Obtiene los archivos adjuntos de un chat específico
   * @param {number} chatId - ID del chat
   * @param {object} params - Parámetros de consulta
   * @param {number} params.page - Número de página (default: 1)
   * @param {number} params.page_size - Cantidad de archivos por página (default: 20)
   * @param {string} params.file_type - Tipo de archivo a filtrar (ALL, IMAGE, VIDEO, DOCUMENT, AUDIO, PDF)
   * @param {string} params.search - Término de búsqueda por nombre de archivo
   * @returns {Promise} - Respuesta con los archivos adjuntos
   */
  getAttachments(chatId, params = {}) {
    const {
      page = 1,
      page_size = 20,
      file_type = 'ALL',
      search = ''
    } = params;

    let queryParams = `page=${page}&page_size=${page_size}`;

    if (file_type && file_type !== 'ALL') {
      queryParams += `&file_type=${file_type}`;
    }

    if (search && search.trim() !== '') {
      queryParams += `&search=${encodeURIComponent(search.trim())}`;
    }

    return apiClientPbx.get(`api/chat/${chatId}/attachments/?${queryParams}`);
  },

  /**
   * Obtiene el mensaje completo asociado a un archivo adjunto
   * @param {number} chatId - ID del chat
   * @param {number} messageId - ID del mensaje
   * @returns {Promise} - Respuesta con el mensaje completo
   */
  getMessageById(chatId, messageId) {
    return apiClientPbx.get(`api/chat/${chatId}/messages/${messageId}/`);
  }
};
